import React from 'react';
import { ProjectRow } from '../../lib/types';

interface DiscoveryColumn {
  id: string;
  title: string;
  description: string;
  statuses: ProjectRow['Status'][];
}

const DISCOVERY_COLUMNS: DiscoveryColumn[] = [
  {
    id: 'new-idea',
    title: 'New Idea',
    description: 'Just submitted, awaiting feedback',
    statuses: ['NewIdea'],
  },
  {
    id: 'gathering-feedback',
    title: 'Gathering Feedback',
    description: 'In discussion with users and stakeholders',
    statuses: ['GatheringFeedback'],
  },
  {
    id: 'ready-for-governance',
    title: 'Ready for Governance',
    description: 'Validated and ready for assessment',
    statuses: ['ReadyForGovernance'],
  },
];

export interface DiscoveryBoardProps {
  projects: ProjectRow[];
  onSelectProject: (id: string | null) => void;
}

export function DiscoveryBoard({ projects, onSelectProject }: DiscoveryBoardProps) {
  const getProjectsForColumn = (statuses: ProjectRow['Status'][]): ProjectRow[] => {
    return projects.filter(p => statuses.includes(p.Status));
  };

  return (
    <div className="discovery-board">
        {DISCOVERY_COLUMNS.map(column => (
          <div key={column.id} className="discovery-column">
            <div className="column-header">
              <h3>{column.title}</h3>
              <span className="column-count">
                {getProjectsForColumn(column.statuses).length}
              </span>
            </div>
            <p className="column-description">{column.description}</p>
            <div className="column-cards">
              {getProjectsForColumn(column.statuses).map(project => (
                <div
                  key={project.ProjectId}
                  className={`project-card ${project.RiskComplianceSecurityFlag ? 'flagged' : ''}`}
                  onClick={() => onSelectProject(project.ProjectId)}
                  role="button"
                  tabIndex={0}
                >
                  <div className="card-header">
                    <span className="card-id">{project.ProjectId}</span>
                  </div>
                  <h4 className="card-title">{project.Title}</h4>
                  <div className="card-meta">
                    <span className="card-domain">{project.Domain}</span>
                    <span className="card-type">{project.WorkType}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
}
